import React from 'react';
import { Layer } from 'react-konva';

import {
  DATE_COLUMN_WIDTH,
  HEADER_ROW_HEIGHT,
  COLUMN_WIDTH,
  COLUMN_HEIGHT,
} from 'src/pages/gantt/gantt-calendar/gantt-view/gantt-view.constants';

import { IInfoLayer } from './info-layer.interface';
import { AvailableHoursBadge } from './available-hours-badge';

const InfoLayer = ({ ganttData, dateMapByDate }: IInfoLayer) => (
  <Layer listening={false}>
    {ganttData.map(({ ganttRecords = [], employee }, employeeIndex) => (
      <React.Fragment key={employeeIndex}>
        {ganttRecords.map(({ dateString, availableWorkingHours }: any) => {
          if (!dateMapByDate[dateString]) return null;

          const { index: startDateIndex } = dateMapByDate[dateString];
          const columnStartX = employeeIndex * COLUMN_WIDTH + DATE_COLUMN_WIDTH;
          const columnStartY = COLUMN_HEIGHT * startDateIndex + HEADER_ROW_HEIGHT;

          return (
            <AvailableHoursBadge
              key={`${employee._id}-${dateString}`}
              columnPoints={[columnStartX, columnStartY]}
              availableWorkingHours={availableWorkingHours}
            />
          );
        })}
      </React.Fragment>
    ))}
  </Layer>
);

export default InfoLayer;
